import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import GreenLeafApi from '../utils/GreenLeafApi';

class AssessmentSelector extends Component {

  constructor(props) {
    super(props);

    this.state = {
      assessments: [],
      assessment: props.assessment || null
    };
  }

  handleAssessmentChange = (assessment) => {
    this.setState({assessment});

    if (this.props.onSelect) {
      this.props.onSelect(assessment);
    }
  };

  getAssessments = (input, callback) => {
    return GreenLeafApi.Assessment.find()
      .then(res => {
        if (res.isOkay) {
          return callback(null, { options: res.data, complete: true });
        }
      })
      .catch(err => {
        return callback(err, null);
      });
  };

  render() {
    return (
      <Select.Async
        multi={false}
        value={this.state.assessment}
        onChange={this.handleAssessmentChange}
        loadOptions={this.getAssessments}
        labelKey="name"
        valueKey="name"
      />
    );
  }
}

AssessmentSelector.propTypes = {
  assessment: PropTypes.object,
  onSelect: PropTypes.func,
};

export default AssessmentSelector;



// WEBPACK FOOTER //
// ./src/components/teams/AssessmentSelector.js